<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-upload"
      @click="dialogVisible = true"
      >导入</el-button
    >

    <el-dialog
      class="upload"
      title="导入"
      :visible.sync="dialogVisible"
      top="29vh"
      width="500px"
      :lock-scroll="false"
      :close-on-click-modal="false"
    >
      <div class="fn-text-center" style="margin-bottom: 20px">
        <file-upload
          url="/api/publicity/addpublicityrange"
          :showFileList="false"
          text="上传批量数据文件"
          :file-list.sync="fileUploadList"
          accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          :size-limit="0"
          :num-limit="0"
          @complete="uploadComplete"
        >
          <div></div>
        </file-upload>
      </div>
      <el-alert title="注意：" type="info" show-icon :closable="false">
        <div>
          <p>1. 文件模板仅支持上传“申报公示名称+完成时间”的表格模板；</p>
          <p>2. 仅支持表格上传；</p>
          <p>
            3.
            <a
              style="color: rgb(25, 119, 255)"
              href="http://47.94.109.100:8725/File/Common/%E7%94%B3%E6%8A%A5%E5%85%AC%E7%A4%BA%E6%95%B0%E6%8D%AE%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx"
              download
              >下载模板</a
            >
          </p>
        </div>
      </el-alert>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "publicityFileUpload",
  data() {
    return {
      dialogVisible: false,
      fileUploadList: []
    };
  },
  methods: {
    uploadComplete() {
      this.dialogVisible = false;
      this.$emit("complete", true);
    }
  }
};
</script>

<style lang="less" scoped></style>
